export class ListScanJobsInternal200Response {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "data",
            "baseName": "data",
            "type": "Array<ScanJob>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListScanJobsInternal200Response.attributeTypeMap;
    }
    constructor() {
    }
}
